import { createSelector } from "@reduxjs/toolkit";

export const discountState = (state) => state.discount;

export const discountSelector = createSelector(discountState, (state) => state);
